import React from 'react';
import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { ASSET_NAME } from './TermsOfServicePage.duck';
import { LayoutSingleColumn, Page } from '../../components';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import { propTypes } from '../../util/types';

import css from './TermsOfServicePage.module.css';

const TermsOfServiceContent = () => {
  return (
    <div className={css.root}>
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html:
            '.lst-kix_85ul459hn5y0-1>li:before{content:"\\0025cb   "}.lst-kix_85ul459hn5y0-2>li:before{content:"\\0025a0   "}.lst-kix_85ul459hn5y0-5>li:before{content:"\\0025a0   "}.lst-kix_85ul459hn5y0-3>li:before{content:"\\0025cf   "}.lst-kix_85ul459hn5y0-4>li:before{content:"\\0025cb   "}ul.lst-kix_nvgwfe7gpdkj-7{list-style-type:none}ul.lst-kix_nvgwfe7gpdkj-8{list-style-type:none}ul.lst-kix_hmhrgf3mtbks-0{list-style-type:none}ul.lst-kix_hmhrgf3mtbks-1{list-style-type:none}ul.lst-kix_hmhrgf3mtbks-2{list-style-type:none}.lst-kix_85ul459hn5y0-0>li:before{content:"\\0025cf   "}.lst-kix_diqlq31g9x8t-0>li:before{content:"\\0025cf   "}.lst-kix_diqlq31g9x8t-2>li:before{content:"\\0025a0   "}.lst-kix_diqlq31g9x8t-3>li:before{content:"\\0025cf   "}.lst-kix_diqlq31g9x8t-1>li:before{content:"\\0025cb   "}.lst-kix_diqlq31g9x8t-6>li:before{content:"\\0025cf   "}.lst-kix_diqlq31g9x8t-7>li:before{content:"\\0025cb   "}.lst-kix_diqlq31g9x8t-4>li:before{content:"\\0025cb   "}.lst-kix_diqlq31g9x8t-8>li:before{content:"\\0025a0   "}.lst-kix_diqlq31g9x8t-5>li:before{content:"\\0025a0   "}.lst-kix_t6e866i9uta3-8>li:before{content:"\\0025a0   "}.lst-kix_5tzmwh2pi21s-7>li:before{content:"\\0025cb   "}ul.lst-kix_hmhrgf3mtbks-7{list-style-type:none}ul.lst-kix_hmhrgf3mtbks-8{list-style-type:none}.lst-kix_5tzmwh2pi21s-6>li:before{content:"\\0025cf   "}.lst-kix_5tzmwh2pi21s-8>li:before{content:"\\0025a0   "}ul.lst-kix_hmhrgf3mtbks-3{list-style-type:none}ul.lst-kix_hmhrgf3mtbks-4{list-style-type:none}ul.lst-kix_hmhrgf3mtbks-5{list-style-type:none}.lst-kix_t6e866i9uta3-2>li:before{content:"\\0025a0   "}ul.lst-kix_hmhrgf3mtbks-6{list-style-type:none}.lst-kix_t6e866i9uta3-1>li:before{content:"\\0025cb   "}.lst-kix_t6e866i9uta3-0>li:before{content:"\\0025cf   "}.lst-kix_t6e866i9uta3-7>li:before{content:"\\0025cb   "}.lst-kix_t6e866i9uta3-6>li:before{content:"\\0025cf   "}.lst-kix_t6e866i9uta3-3>li:before{content:"\\0025cf   "}.lst-kix_t6e866i9uta3-5>li:before{content:"\\0025a0   "}.lst-kix_t6e866i9uta3-4>li:before{content:"\\0025cb   "}.lst-kix_1zkmy86yr7f7-2>li:before{content:"\\0025a0   "}.lst-kix_1zkmy86yr7f7-4>li:before{content:"\\0025cb   "}.lst-kix_5tzmwh2pi21s-4>li:before{content:"\\0025cb   "}.lst-kix_4w4owqcpt5lg-7>li:before{content:"\\0025cb   "}.lst-kix_1zkmy86yr7f7-0>li:before{content:"\\0025cf   "}.lst-kix_4w4owqcpt5lg-1>li:before{content:"\\0025cb   "}.lst-kix_4w4owqcpt5lg-3>li:before{content:"\\0025cf   "}.lst-kix_5tzmwh2pi21s-2>li:before{content:"\\0025a0   "}.lst-kix_4w4owqcpt5lg-5>li:before{content:"\\0025a0   "}.lst-kix_5tzmwh2pi21s-0>li:before{content:"\\0025cf   "}.lst-kix_l2zwebkr3nqq-6>li:before{content:"\\0025cf   "}.lst-kix_l2zwebkr3nqq-4>li:before{content:"\\0025cb   "}.lst-kix_l2zwebkr3nqq-8>li:before{content:"\\0025a0   "}ul.lst-kix_pgdqg6y2f1fk-7{list-style-type:none}ul.lst-kix_pgdqg6y2f1fk-8{list-style-type:none}ul.lst-kix_pgdqg6y2f1fk-5{list-style-type:none}ul.lst-kix_pgdqg6y2f1fk-6{list-style-type:none}.lst-kix_l2zwebkr3nqq-0>li:before{content:"\\0025cf   "}.lst-kix_l2zwebkr3nqq-2>li:before{content:"\\0025a0   "}.lst-kix_1zkmy86yr7f7-6>li:before{content:"\\0025cf   "}.lst-kix_85ul459hn5y0-7>li:before{content:"\\0025cb   "}.lst-kix_1zkmy86yr7f7-8>li:before{content:"\\0025a0   "}.lst-kix_nvgwfe7gpdkj-3>li:before{content:"\\0025cf   "}.lst-kix_nvgwfe7gpdkj-2>li:before{content:"\\0025a0   "}.lst-kix_nvgwfe7gpdkj-6>li:before{content:"\\0025cf   "}.lst-kix_p9yg99oct9c7-8>li:before{content:"\\0025a0   "}.lst-kix_nvgwfe7gpdkj-7>li:before{content:"\\0025cb   "}.lst-kix_p9yg99oct9c7-5>li:before{content:"\\0025a0   "}.lst-kix_nvgwfe7gpdkj-1>li:before{content:"\\0025cb   "}.lst-kix_p9yg99oct9c7-7>li:before{content:"\\0025cb   "}.lst-kix_pgdqg6y2f1fk-4>li:before{content:"\\0025cb   "}.lst-kix_nvgwfe7gpdkj-0>li:before{content:"\\0025cf   "}.lst-kix_nvgwfe7gpdkj-8>li:before{content:"\\0025a0   "}.lst-kix_p9yg99oct9c7-6>li:before{content:"\\0025cf   "}.lst-kix_pgdqg6y2f1fk-5>li:before{content:"\\0025a0   "}.lst-kix_p9yg99oct9c7-1>li:before{content:"\\0025cb   "}ul.lst-kix_pgdqg6y2f1fk-0{list-style-type:none}ul.lst-kix_pgdqg6y2f1fk-3{list-style-type:none}ul.lst-kix_pgdqg6y2f1fk-4{list-style-type:none}.lst-kix_p9yg99oct9c7-0>li:before{content:"\\0025cf   "}.lst-kix_p9yg99oct9c7-4>li:before{content:"\\0025cb   "}ul.lst-kix_pgdqg6y2f1fk-1{list-style-type:none}.lst-kix_pgdqg6y2f1fk-3>li:before{content:"\\0025cf   "}ul.lst-kix_pgdqg6y2f1fk-2{list-style-type:none}.lst-kix_pgdqg6y2f1fk-2>li:before{content:"\\0025a0   "}.lst-kix_nvgwfe7gpdkj-5>li:before{content:"\\0025a0   "}.lst-kix_p9yg99oct9c7-3>li:before{content:"\\0025cf   "}.lst-kix_pgdqg6y2f1fk-0>li:before{content:"\\0025cf   "}.lst-kix_nvgwfe7gpdkj-4>li:before{content:"\\0025cb   "}.lst-kix_p9yg99oct9c7-2>li:before{content:"\\0025a0   "}.lst-kix_pgdqg6y2f1fk-1>li:before{content:"\\0025cb   "}.lst-kix_pgdqg6y2f1fk-6>li:before{content:"\\0025cf   "}.lst-kix_pgdqg6y2f1fk-7>li:before{content:"\\0025cb   "}.lst-kix_pgdqg6y2f1fk-8>li:before{content:"\\0025a0   "}.lst-kix_hmhrgf3mtbks-5>li:before{content:"\\0025a0   "}.lst-kix_hmhrgf3mtbks-6>li:before{content:"\\0025cf   "}.lst-kix_hmhrgf3mtbks-1>li:before{content:"\\0025cb   "}.lst-kix_hmhrgf3mtbks-0>li:before{content:"\\0025cf   "}.lst-kix_hmhrgf3mtbks-7>li:before{content:"\\0025cb   "}.lst-kix_hmhrgf3mtbks-8>li:before{content:"\\0025a0   "}.lst-kix_hmhrgf3mtbks-2>li:before{content:"\\0025a0   "}.lst-kix_hmhrgf3mtbks-3>li:before{content:"\\0025cf   "}.lst-kix_hmhrgf3mtbks-4>li:before{content:"\\0025cb   "}ul.lst-kix_85ul459hn5y0-8{list-style-type:none}ul.lst-kix_85ul459hn5y0-7{list-style-type:none}.lst-kix_1zkmy86yr7f7-3>li:before{content:"\\0025cf   "}.lst-kix_1zkmy86yr7f7-1>li:before{content:"\\0025cb   "}.lst-kix_1zkmy86yr7f7-5>li:before{content:"\\0025a0   "}ul.lst-kix_85ul459hn5y0-0{list-style-type:none}ul.lst-kix_85ul459hn5y0-2{list-style-type:none}ul.lst-kix_85ul459hn5y0-1{list-style-type:none}ul.lst-kix_85ul459hn5y0-4{list-style-type:none}ul.lst-kix_85ul459hn5y0-3{list-style-type:none}ul.lst-kix_85ul459hn5y0-6{list-style-type:none}ul.lst-kix_85ul459hn5y0-5{list-style-type:none}ul.lst-kix_p9yg99oct9c7-2{list-style-type:none}ul.lst-kix_diqlq31g9x8t-7{list-style-type:none}ul.lst-kix_p9yg99oct9c7-1{list-style-type:none}ul.lst-kix_diqlq31g9x8t-6{list-style-type:none}ul.lst-kix_l2zwebkr3nqq-8{list-style-type:none}ul.lst-kix_p9yg99oct9c7-4{list-style-type:none}ul.lst-kix_l2zwebkr3nqq-7{list-style-type:none}ul.lst-kix_p9yg99oct9c7-3{list-style-type:none}ul.lst-kix_diqlq31g9x8t-8{list-style-type:none}ul.lst-kix_t6e866i9uta3-1{list-style-type:none}ul.lst-kix_t6e866i9uta3-2{list-style-type:none}ul.lst-kix_p9yg99oct9c7-0{list-style-type:none}ul.lst-kix_t6e866i9uta3-0{list-style-type:none}.lst-kix_4w4owqcpt5lg-6>li:before{content:"\\0025cf   "}ul.lst-kix_l2zwebkr3nqq-2{list-style-type:none}ul.lst-kix_t6e866i9uta3-5{list-style-type:none}ul.lst-kix_l2zwebkr3nqq-1{list-style-type:none}ul.lst-kix_t6e866i9uta3-6{list-style-type:none}ul.lst-kix_l2zwebkr3nqq-0{list-style-type:none}ul.lst-kix_t6e866i9uta3-3{list-style-type:none}ul.lst-kix_diqlq31g9x8t-1{list-style-type:none}ul.lst-kix_t6e866i9uta3-4{list-style-type:none}ul.lst-kix_diqlq31g9x8t-0{list-style-type:none}.lst-kix_5tzmwh2pi21s-5>li:before{content:"\\0025a0   "}ul.lst-kix_l2zwebkr3nqq-6{list-style-type:none}ul.lst-kix_p9yg99oct9c7-6{list-style-type:none}ul.lst-kix_diqlq31g9x8t-3{list-style-type:none}ul.lst-kix_l2zwebkr3nqq-5{list-style-type:none}ul.lst-kix_p9yg99oct9c7-5{list-style-type:none}ul.lst-kix_diqlq31g9x8t-2{list-style-type:none}ul.lst-kix_l2zwebkr3nqq-4{list-style-type:none}ul.lst-kix_t6e866i9uta3-7{list-style-type:none}ul.lst-kix_p9yg99oct9c7-8{list-style-type:none}ul.lst-kix_diqlq31g9x8t-5{list-style-type:none}ul.lst-kix_l2zwebkr3nqq-3{list-style-type:none}ul.lst-kix_t6e866i9uta3-8{list-style-type:none}.lst-kix_4w4owqcpt5lg-8>li:before{content:"\\0025a0   "}ul.lst-kix_p9yg99oct9c7-7{list-style-type:none}ul.lst-kix_diqlq31g9x8t-4{list-style-type:none}.lst-kix_4w4owqcpt5lg-2>li:before{content:"\\0025a0   "}.lst-kix_5tzmwh2pi21s-3>li:before{content:"\\0025cf   "}.lst-kix_5tzmwh2pi21s-1>li:before{content:"\\0025cb   "}ul.lst-kix_5tzmwh2pi21s-6{list-style-type:none}ul.lst-kix_5tzmwh2pi21s-5{list-style-type:none}ul.lst-kix_5tzmwh2pi21s-8{list-style-type:none}ul.lst-kix_5tzmwh2pi21s-7{list-style-type:none}.lst-kix_4w4owqcpt5lg-4>li:before{content:"\\0025cb   "}ul.lst-kix_5tzmwh2pi21s-2{list-style-type:none}ul.lst-kix_5tzmwh2pi21s-1{list-style-type:none}ul.lst-kix_5tzmwh2pi21s-4{list-style-type:none}ul.lst-kix_5tzmwh2pi21s-3{list-style-type:none}ul.lst-kix_5tzmwh2pi21s-0{list-style-type:none}.lst-kix_4w4owqcpt5lg-0>li:before{content:"\\0025cf   "}ul.lst-kix_4w4owqcpt5lg-8{list-style-type:none}ul.lst-kix_4w4owqcpt5lg-2{list-style-type:none}ul.lst-kix_4w4owqcpt5lg-3{list-style-type:none}ul.lst-kix_4w4owqcpt5lg-0{list-style-type:none}ul.lst-kix_4w4owqcpt5lg-1{list-style-type:none}ul.lst-kix_4w4owqcpt5lg-6{list-style-type:none}ul.lst-kix_4w4owqcpt5lg-7{list-style-type:none}ul.lst-kix_4w4owqcpt5lg-4{list-style-type:none}ul.lst-kix_4w4owqcpt5lg-5{list-style-type:none}ul.lst-kix_1zkmy86yr7f7-2{list-style-type:none}.lst-kix_l2zwebkr3nqq-5>li:before{content:"\\0025a0   "}ul.lst-kix_1zkmy86yr7f7-3{list-style-type:none}ul.lst-kix_1zkmy86yr7f7-4{list-style-type:none}ul.lst-kix_1zkmy86yr7f7-5{list-style-type:none}.lst-kix_l2zwebkr3nqq-3>li:before{content:"\\0025cf   "}.lst-kix_l2zwebkr3nqq-7>li:before{content:"\\0025cb   "}ul.lst-kix_1zkmy86yr7f7-0{list-style-type:none}ul.lst-kix_1zkmy86yr7f7-1{list-style-type:none}ul.lst-kix_nvgwfe7gpdkj-1{list-style-type:none}ul.lst-kix_nvgwfe7gpdkj-2{list-style-type:none}ul.lst-kix_nvgwfe7gpdkj-0{list-style-type:none}ul.lst-kix_nvgwfe7gpdkj-5{list-style-type:none}ul.lst-kix_1zkmy86yr7f7-6{list-style-type:none}ul.lst-kix_nvgwfe7gpdkj-6{list-style-type:none}ul.lst-kix_1zkmy86yr7f7-7{list-style-type:none}li.li-bullet-0:before{margin-left:-18pt;white-space:nowrap;display:inline-block;min-width:18pt}ul.lst-kix_nvgwfe7gpdkj-3{list-style-type:none}ul.lst-kix_1zkmy86yr7f7-8{list-style-type:none}ul.lst-kix_nvgwfe7gpdkj-4{list-style-type:none}.lst-kix_85ul459hn5y0-6>li:before{content:"\\0025cf   "}.lst-kix_l2zwebkr3nqq-1>li:before{content:"\\0025cb   "}.lst-kix_1zkmy86yr7f7-7>li:before{content:"\\0025cb   "}.lst-kix_85ul459hn5y0-8>li:before{content:"\\0025a0   "}ol{margin:0;padding:0}table td,table th{padding:0}.c15{padding-top:16pt;padding-bottom:4pt;line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}.c11{padding-top:14pt;padding-bottom:4pt;line-height:1.15;orphans:2;widows:2;text-align:left;height:14pt}.c0{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:11pt;font-family:"Arial";font-style:normal}.c9{color:#000000;text-decoration:none;vertical-align:baseline;font-size:13pt;font-family:"Arial";font-style:normal}.c12{padding-top:0pt;padding-bottom:0pt;line-height:1.15;orphans:2;widows:2;text-align:left}.c14{padding-top:0pt;padding-bottom:12pt;line-height:1.15;orphans:2;widows:2;text-align:left}.c13{padding-top:14pt;padding-bottom:4pt;line-height:1.15;orphans:2;widows:2;text-align:left}.c7{color:#434343;text-decoration:none;vertical-align:baseline;font-size:11pt;font-family:"Arial";font-style:normal}.c1{padding-top:12pt;padding-bottom:12pt;line-height:1.15;orphans:2;widows:2;text-align:left}.c8{color:#000000;text-decoration:none;vertical-align:baseline;font-size:11pt;font-family:"Arial";font-style:normal}.c10{text-decoration-skip-ink:none;-webkit-text-decoration-skip:none;color:#1155cc;text-decoration:underline}.c16{background-color:#ffffff;max-width:451.4pt;padding:72pt 72pt 72pt 72pt}.c5{padding:0;margin:0}.c3{color:inherit;text-decoration:inherit}.c4{margin-left:36pt;padding-left:0pt}.c2{font-weight:700}.c6{height:11pt}.title{padding-top:0pt;color:#000000;font-size:26pt;padding-bottom:3pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}.subtitle{padding-top:0pt;color:#666666;font-size:15pt;padding-bottom:16pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}li{color:#000000;font-size:11pt;font-family:"Arial"}p{margin:0;color:#000000;font-size:11pt;font-family:"Arial"}h1{padding-top:20pt;color:#000000;font-size:20pt;padding-bottom:6pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h2{padding-top:18pt;color:#000000;font-size:16pt;padding-bottom:6pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h3{padding-top:16pt;color:#434343;font-size:14pt;padding-bottom:4pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h4{padding-top:14pt;color:#666666;font-size:12pt;padding-bottom:4pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h5{padding-top:12pt;color:#666666;font-size:11pt;padding-bottom:4pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;orphans:2;widows:2;text-align:left}h6{padding-top:12pt;color:#666666;font-size:11pt;padding-bottom:4pt;font-family:"Arial";line-height:1.15;page-break-after:avoid;font-style:italic;orphans:2;widows:2;text-align:left}',
        }}
      />
      <p className="c6 c12">
        <span className="c0" />
      </p>
      <h3 className="c13" id="h.ods3v1n9b4ba">
        <span className="c9 c2">Artikel 1 – Definities</span>
      </h3>
      <p className="c1">
        <span className="c0">In deze algemene voorwaarden wordt verstaan onder:</span>
      </p>
      <p className="c1">
        <span className="c2">1.1. Vaarmarkt:</span>
        <span>&nbsp;de besloten vennootschap </span>
        <span className="c2">Nauticlink B.V.</span>
        <span>
          , handelend onder de naam Vaarmarkt.nl, statutair gevestigd aan de Katwolderweg te Zwolle
          (8041 AC), ingeschreven bij de Kamer van Koophandel onder nummer{' '}
        </span>
        <span className="c2">80526314</span>
        <span className="c0">, exploitant van het online platform Vaarmarkt.nl.</span>
      </p>
      <p className="c1">
        <span className="c2">1.2. Platform:</span>
        <span>
          &nbsp;de online marktplaats en bijbehorende diensten van Vaarmarkt, bereikbaar via
        </span>
        <span>
          <a
            className="c3"
            href="https://www.google.com/url?q=http://www.vaarmarkt.nl&sa=D&source=editors&ust=1751326159334289&usg=AOvVaw0Nbzh-GQdWPUx1sw8yicD4"
          >
            &nbsp;
          </a>
        </span>
        <span className="c10">
          <a
            className="c3"
            href="https://www.google.com/url?q=http://www.vaarmarkt.nl&sa=D&source=editors&ust=1751326159334364&usg=AOvVaw3Ie29_75Ea4PBMsIqZRgru"
          >
            www.vaarmarkt.nl
          </a>
        </span>
        <span className="c0">
          , inclusief alle mobiele applicaties en andere digitale uitingen, waarmee Vaarmarkt
          Gebruikers in staat stelt advertenties te plaatsen, content te delen en informatie over
          producten en diensten in de watersportsector te bekijken of aan te bieden.
        </span>
      </p>
      <p className="c1">
        <span className="c2">1.3. Gebruiker:</span>
        <span className="c0">
          &nbsp;iedere natuurlijke persoon of rechtspersoon die het Platform bezoekt of gebruikt,
          ongeacht of deze een Account aanmaakt of een transactie aangaat. Hieronder vallen ook
          Adverteerders, Kopers, Consumenten en Zakelijke Gebruikers.
        </span>
      </p>
      <p className="c1">
        <span className="c2">1.4. Adverteerder (ook: Verkoper):</span>
        <span className="c0">
          &nbsp;een Gebruiker die via het Platform een Advertentie plaatst met het doel om een
          product of dienst aan te bieden.
        </span>
      </p>
      <p className="c1">
        <span className="c2">1.5. Koper:</span>
        <span className="c0">
          &nbsp;een Gebruiker die via het Platform belangstelling toont voor, reageert op of
          overgaat tot de aankoop of afname van een product of dienst van een Adverteerder.
        </span>
      </p>
      <p className="c1">
        <span className="c2">1.6. Consument:</span>
        <span className="c0">
          &nbsp;een Gebruiker (natuurlijk persoon) die handelt voor doeleinden die buiten zijn
          bedrijfs- of beroepsactiviteit vallen, zoals bedoeld in artikel 6:230g lid 1 van het
          Burgerlijk Wetboek.
        </span>
      </p>
      <p className="c1">
        <span className="c2">1.7. Zakelijke Gebruiker:</span>
        <span className="c0">
          &nbsp;een Gebruiker (rechtspersoon of natuurlijke persoon) die handelt in de uitoefening
          van een beroep of bedrijf, waaronder mede begrepen professionele verkopers en
          adverteerders.
        </span>
      </p>
      <p className="c1">
        <span className="c2">1.8. Advertentie:</span>
        <span className="c0">
          &nbsp;een door een Adverteerder op het Platform geplaatste openbare aanbieding of oproep,
          inclusief titel, omschrijving, prijs en eventueel beeldmateriaal, die betrekking heeft op
          een aan te bieden of gezochte boot, onderdeel, dienst of ander watersportgerelateerd
          product.
        </span>
      </p>
      <p className="c1">
        <span className="c2">1.9. Overeenkomst:</span>
        <span className="c0">
          &nbsp;een overeenkomst (bijvoorbeeld een koopovereenkomst) die tot stand komt tussen een
          Adverteerder en een Koper naar aanleiding van een via het Platform geplaatste Advertentie.
          Vaarmarkt is hierbij geen partij, tenzij uitdrukkelijk anders is vermeld.
        </span>
      </p>
      <p className="c1">
        <span className="c2">1.10. Content:</span>
        <span className="c0">
          &nbsp;alle informatie en materialen die door Gebruikers via het Platform worden geplaatst
          of uitgewisseld, waaronder teksten, foto’s, video’s, beschrijvingen, reacties, reviews en
          berichten.
        </span>
      </p>
      <p className="c1">
        <span className="c2">1.11. Account:</span>
        <span className="c0">
          &nbsp;het gebruikersprofiel dat door een Gebruiker wordt aangemaakt via het Platform,
          waarmee toegang wordt verkregen tot persoonlijke instellingen en functionaliteiten zoals
          het plaatsen of beheren van Advertenties.
        </span>
      </p>
      <p className="c1">
        <span className="c2">1.12. Diensten:</span>
        <span className="c0">
          &nbsp;de door Vaarmarkt aangeboden functionaliteiten, waaronder het aanbieden van
          advertentieruimte, het mogelijk maken van communicatie tussen Gebruikers, het verwerken
          van betaalde plaatsingen, en alle overige via het Platform geboden diensten.
        </span>
      </p>
      <p className="c1">
        <span className="c2">1.13. Algemene Voorwaarden:</span>
        <span className="c0">
          &nbsp;deze algemene voorwaarden van Vaarmarkt.nl, zoals van toepassing verklaard bij
          registratie of gebruik van het Platform.
        </span>
      </p>
      <p className="c1">
        <span className="c2">1.14. Schriftelijk:</span>
        <span className="c0">
          &nbsp;onder "schriftelijk" wordt mede verstaan elektronische communicatie per e-mail, mits
          de identiteit van de afzender en de integriteit van het bericht voldoende vaststaan.
        </span>
      </p>
      <p className="c1">
        <span className="c2">1.15. Bezoeker:</span>
        <span className="c0">
          &nbsp;een natuurlijk persoon die het Platform raadpleegt zonder een Account aan te maken
          of in te loggen, bijvoorbeeld om algemene informatie, persberichten, vaarroutes, weer- of
          getijdendata te bekijken. Bezoekers vallen onder het bereik van deze Algemene Voorwaarden
          voor zover zij gebruikmaken van publiek toegankelijke functionaliteiten of content op het
          Platform.
        </span>
      </p>
      <p className="c1 c6">
        <span className="c0" />
      </p>
      <h3 className="c13" id="h.c5sapq44rhws">
        <span className="c9 c2">Artikel 2 – Toepasselijkheid en Identiteit</span>
      </h3>
      <p className="c1">
        <span className="c2">
          2.1. Toepasselijkheid:
          <br />
        </span>
        <span className="c0">
          &nbsp;Deze Algemene Voorwaarden zijn van toepassing op elk gebruik van het Platform en op
          alle diensten die Vaarmarkt levert aan Gebruikers, zowel incidenteel als structureel. Door
          het bezoeken van de website, het aanmaken van een Account, het plaatsen van een
          Advertentie of enig ander gebruik van het Platform verklaart de Gebruiker zich zonder
          voorbehoud akkoord met deze Algemene Voorwaarden. De Algemene Voorwaarden zijn te allen
          tijde beschikbaar via het Platform en kunnen als PDF worden opgeslagen of gedownload op
          een duurzame gegevensdrager.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          2.2. Identiteit van Vaarmarkt:
          <br />
        </span>
        <span className="c0">&nbsp;Het Platform Vaarmarkt.nl wordt geëxploiteerd door:</span>
      </p>
      <p className="c1">
        <span className="c2">
          Nauticlink B.V.
          <br />
        </span>
        <span>&nbsp;Handelend onder de naam: </span>
        <span className="c2">
          Vaarmarkt.nl
          <br />
        </span>
        <span>&nbsp;Vestigingsadres: </span>
        <span className="c2">
          Katwolderweg 7, 8041 AC Zwolle, Nederland
          <br />
        </span>
        <span>&nbsp;E-mailadres: </span>
        <span className="c2">
          info@vaarmarkt.nl
          <br />
        </span>
        <span>&nbsp;KvK-nummer: </span>
        <span className="c2">
          80526314
          <br />
        </span>
        <span>&nbsp;BTW-identificatienummer: </span>
        <span className="c2 c8">NL8617.02.128.B01</span>
      </p>
      <p className="c1">
        <span className="c2">
          2.3. Versie en wijziging van de voorwaarden:
          <br />
        </span>
        <span>Deze Algemene Voorwaarden (versie 1.0) treden in werking op </span>
        <span className="c2">1 juni 2025</span>
        <span className="c0">
          . Vaarmarkt behoudt zich het recht voor om deze voorwaarden eenzijdig te wijzigen. In dat
          geval zal Vaarmarkt Gebruikers ten minste 30 dagen vóór inwerkingtreding van de
          wijzigingen informeren via het Platform en/of per e-mail. Indien de Gebruiker na
          inwerkingtreding van de gewijzigde voorwaarden gebruik blijft maken van het Platform,
          wordt hij geacht met de wijzigingen te hebben ingestemd. Indien de Gebruiker niet akkoord
          gaat, kan hij de Overeenkomst beëindigen zoals geregeld in artikel 12.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          2.4. Afwijzing van andere voorwaarden:
          <br />
        </span>
        <span className="c0">
          Toepasselijkheid van algemene (inkoop)voorwaarden van de Gebruiker wordt uitdrukkelijk van
          de hand gewezen, tenzij Vaarmarkt hiermee uitdrukkelijk en schriftelijk heeft ingestemd.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          2.5. Deelbaarheid:
          <br />
        </span>
        <span className="c0">
          Indien een bepaling uit deze Algemene Voorwaarden nietig blijkt te zijn, vernietigd wordt
          of om enige reden ongeldig of onafdwingbaar is, laat dit de geldigheid van de overige
          bepalingen onverlet. In dat geval zullen partijen in overleg treden om de betreffende
          bepaling te vervangen door een rechtsgeldige bepaling die de strekking van het
          oorspronkelijke beding zo dicht mogelijk benadert.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          2.6. Consumentenbescherming:
          <br />
        </span>
        <span className="c0">
          Voor zover de Gebruiker een Consument is, laten deze Algemene Voorwaarden onverlet de
          rechten en aanspraken die dwingendrechtelijk aan consumenten toekomen op grond van het
          Nederlandse of Europese consumentenrecht. Bij tegenstrijdigheid tussen een bepaling in
          deze voorwaarden en dwingend consumentenrecht, prevaleren de laatstgenoemde wettelijke
          regels.
        </span>
      </p>
      <h3 className="c13" id="h.tn278b92wui9">
        <span className="c9 c2">Artikel 3 – Diensten van Vaarmarkt en rol van het Platform</span>
      </h3>
      <p className="c1">
        <span className="c2">
          3.1. Marktplaatsfunctie en gebruiksdoel
          <br />
        </span>
        <span>Vaarmarkt exploiteert een online platform (</span>
        <span className="c10">
          <a
            className="c3"
            href="https://www.google.com/url?q=http://www.vaarmarkt.nl&sa=D&source=editors&ust=1751326159339868&usg=AOvVaw0caG75Z_KoD5t36Xfs558G"
          >
            www.vaarmarkt.nl
          </a>
        </span>
        <span className="c0">
          ) dat vraag en aanbod binnen de watersportsector samenbrengt. Gebruikers kunnen
          Advertenties plaatsen en reageren op elkaars aanbiedingen. Vaarmarkt faciliteert deze
          interacties uitsluitend als technisch en organisatorisch platform, zonder partij te zijn
          bij enige transactie tussen Gebruikers. Vaarmarkt treedt niet op als koper, verkoper,
          bemiddelaar, makelaar of vertegenwoordiger.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          3.2. Aanvullende diensten van Vaarmarkt
          <br />
        </span>
        <span className="c0">
          Naast de marktplaatsfunctie biedt Vaarmarkt aanvullende diensten aan, waaronder maar niet
          beperkt tot:
        </span>
      </p>
      <ul className="c5 lst-kix_hmhrgf3mtbks-0 start">
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            Het gratis plaatsen en publiceren van persberichten op de website, in nieuwsbrieven of
            andere media-uitingen van Vaarmarkt (al dan niet in aangepaste vorm);
            <br />
          </span>
        </li>
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            Het tegen betaling opstellen, redigeren en/of plaatsen van gastblogs of promotionele
            artikelen;
            <br />
          </span>
        </li>
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            De weergave van betaalde bedrijfsprofielen (zogenaamde "Vaarpartners"), inclusief
            banners, logo's, links en beschrijvingen op prominente posities binnen de website, apps
            of nieuwsbrieven;
            <br />
          </span>
        </li>
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            Het verzorgen van losse bannercampagnes en advertentie-uitingen, gericht op
            zichtbaarheid binnen het platform of in bijbehorende media-uitingen.
            <br />
          </span>
        </li>
      </ul>
      <p className="c1">
        <span className="c0">
          Voor al deze diensten geldt dat de inhoud, juistheid en juridische toelaatbaarheid
          (waaronder de eventuele aanwezigheid van inbreukmakende, misleidende of ongeautoriseerde
          elementen) uitsluitend onder verantwoordelijkheid van de aanleverende Gebruiker of klant
          vallen.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          3.3. Vrijwaring en aansprakelijkheidsuitsluiting voor contentdiensten
          <br />
        </span>
        <span className="c0">
          Gebruikers die content, banners, persberichten of andere promotionele materialen
          aanleveren of laten plaatsen, verklaren en garanderen dat:
        </span>
      </p>
      <ul className="c5 lst-kix_4w4owqcpt5lg-0 start">
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            zij gerechtigd zijn tot gebruik en publicatie van alle bijbehorende teksten, beeld- en
            videomateriaal;
            <br />
          </span>
        </li>
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            de inhoud geen inbreuk maakt op rechten van derden (zoals auteursrechten, merkrechten of
            privacyrechten);
            <br />
          </span>
        </li>
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            de informatie feitelijk juist, niet misleidend en wettelijk toegestaan is.
            <br />
          </span>
        </li>
      </ul>
      <p className="c1">
        <span className="c0">
          De Gebruiker vrijwaart Vaarmarkt volledig voor elke vorm van aanspraak, schade of kosten
          van derden die voortvloeien uit door of namens de Gebruiker aangeleverde of geplaatste
          inhoud. Vaarmarkt behoudt zich het recht voor om naar eigen inzicht content te weigeren,
          te redigeren of te verwijderen zonder tot enige schadevergoeding verplicht te zijn.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          3.4. Geen verantwoordelijkheid voor overeenkomsten tussen Gebruikers
          <br />
        </span>
        <span className="c0">
          Vaarmarkt is geen partij bij Overeenkomsten die tot stand komen naar aanleiding van
          Advertenties of andere vormen van communicatie tussen Gebruikers. Vaarmarkt geeft geen
          garanties over de betrouwbaarheid, solvabiliteit, hoedanigheid of intenties van
          Gebruikers, noch over de staat, kwaliteit, prijs of levering van aangeboden producten of
          diensten.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          3.5. Technische beschikbaarheid en onderhoud
          <br />
        </span>
        <span className="c0">
          Vaarmarkt streeft naar een goede technische werking en bereikbaarheid van het Platform,
          maar garandeert niet dat het Platform altijd zonder onderbrekingen, fouten of storingen
          functioneert. Vaarmarkt behoudt zich het recht voor om (delen van) het Platform tijdelijk
          buiten gebruik te stellen ten behoeve van onderhoud, updates of incidentbeheer. Vaarmarkt
          is niet aansprakelijk voor schade als gevolg van niet-beschikbaarheid van het Platform.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          3.6. Beperking van aansprakelijkheid
          <br />
        </span>
        <span className="c0">
          Voor zover wettelijk toegestaan sluit Vaarmarkt iedere directe en indirecte
          aansprakelijkheid uit voor:
        </span>
      </p>
      <ul className="c5 lst-kix_diqlq31g9x8t-0 start">
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            onjuistheden, onvolledigheden of onwettigheden in door Gebruikers geplaatste
            Advertenties, persberichten, banners of andere content;
            <br />
          </span>
        </li>
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            schade voortvloeiend uit het gebruik van het Platform, of uit het niet beschikbaar zijn
            daarvan;
            <br />
          </span>
        </li>
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            geschillen tussen Gebruikers onderling, of tussen een Gebruiker en een derde partij;
            <br />
          </span>
        </li>
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            eventuele schade die voortvloeit uit gebruik of vertrouwen op betaalde promotionele
            diensten of uitingen.
            <br />
          </span>
        </li>
      </ul>
      <p className="c1">
        <span className="c2">
          3.7. Geen verplichting tot bemiddeling of geschilbeslechting
          <br />
        </span>
        <span className="c0">
          Vaarmarkt is niet gehouden om in te grijpen bij geschillen tussen Gebruikers of tussen een
          Gebruiker en een derde partij. Vaarmarkt kan naar eigen inzicht en zonder verplichting
          bemiddelend optreden, doch zal nimmer bindende uitspraken doen of enige aansprakelijkheid
          aanvaarden voor de uitkomst van dergelijke conflicten.
        </span>
      </p>
      <h3 className="c13" id="h.x6m5uyywnzs5">
        <span className="c2 c9">3.8. Gebruik door niet-geregistreerde Bezoekers</span>
      </h3>
      <p className="c1">
        <span>Vaarmarkt</span>
        <span className="c0">
          &nbsp;stelt bepaalde informatie en functionaliteiten op het Platform ook beschikbaar voor
          Bezoekers, zoals persberichten, watersportnieuws, vaarroutes, getijdendata, weerinformatie
          en andere nautische content. Deze informatie wordt verstrekt op algemene, vrijblijvende
          basis. Hoewel Vaarmarkt zich inspant om betrouwbare en actuele informatie aan te bieden,
          aanvaardt zij geen aansprakelijkheid voor eventuele fouten, onjuistheden, storingen of
          verouderde gegevens.
        </span>
      </p>
      <p className="c1">
        <span className="c0">
          Bezoekers zijn gehouden aan deze Algemene Voorwaarden voor zover relevant, in het
          bijzonder de bepalingen over intellectuele eigendomsrechten (artikel 8), uitsluiting van
          aansprakelijkheid (artikel 9) en verboden gedragingen (artikel 6). Door het raadplegen van
          het Platform aanvaarden Bezoekers deze voorwaarden stilzwijgend. Het is zonder
          voorafgaande schriftelijke toestemming van Vaarmarkt niet toegestaan om informatie van het
          Platform te kopiëren, verspreiden of hergebruiken voor commerciële doeleinden.
        </span>
      </p>
      <p className="c1 c6">
        <span className="c0" />
      </p>
      <h3 className="c13" id="h.54g38ujqxa8q">
        <span className="c9 c2">Artikel 4 – Registratie en Account</span>
      </h3>
      <p className="c1">
        <span className="c2">
          4.1. Accountregistratie
          <br />
        </span>
        <span className="c0">
          Om actief gebruik te kunnen maken van het Platform (zoals het plaatsen van een Advertentie
          of het reageren daarop), dient de Gebruiker een persoonlijk Account aan te maken volgens
          de op het Platform beschreven procedure. De Gebruiker verplicht zich om bij registratie
          volledige, juiste en actuele informatie te verstrekken, waaronder een geldig en werkend
          e-mailadres.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          4.2. Minimumleeftijd
          <br />
        </span>
        <span className="c0">
          Registratie is uitsluitend toegestaan voor natuurlijke personen van 18 jaar of ouder.
          Personen jonger dan 18 jaar mogen slechts met toestemming van hun wettelijke
          vertegenwoordiger een Account aanmaken. Vaarmarkt behoudt zich het recht voor om leeftijd
          of identiteit te verifiëren.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          4.3. Eén persoonlijk account; geen misleiding
          <br />
        </span>
        <span className="c0">
          Het Account is strikt persoonlijk en niet overdraagbaar. Het is niet toegestaan meerdere
          accounts aan te maken, inloggegevens met derden te delen of zich voor te doen als een
          andere persoon of entiteit. De Gebruiker zal geen valse, misleidende of onvolledige
          persoonsgegevens gebruiken bij registratie of gebruik van het Platform.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          4.4. Veiligheid en misbruik
          <br />
        </span>
        <span className="c0">
          De Gebruiker is verantwoordelijk voor het geheimhouden van zijn inloggegevens en voor alle
          handelingen die via zijn Account worden verricht. Bij vermoeden van misbruik of
          ongeoorloofd gebruik dient de Gebruiker Vaarmarkt onmiddellijk te informeren en passende
          maatregelen te nemen, zoals het wijzigen van het wachtwoord. Vaarmarkt is gerechtigd het
          Account tijdelijk te blokkeren of te beëindigen ter bescherming van Gebruiker en Platform.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          4.5. Beoordeling en controle
          <br />
        </span>
        <span className="c0">Vaarmarkt behoudt zich het recht voor om:</span>
      </p>
      <ul className="c5 lst-kix_p9yg99oct9c7-0 start">
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            een registratie te weigeren;
            <br />
          </span>
        </li>
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            aanvullende informatie op te vragen (bijvoorbeeld bij vermoeden van misbruik of
            commerciële registratie);
            <br />
          </span>
        </li>
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            een Account tijdelijk of permanent te blokkeren of te beëindigen in geval van fraude,
            misleiding, schending van de voorwaarden of andere ongewenste gedragingen.
            <br /> Zie ook artikel 13 over beëindiging en verwijdering van Accounts.
            <br />
          </span>
        </li>
      </ul>
      <p className="c1">
        <span className="c2">
          4.6. Zakelijk gebruik
          <br />
        </span>
        <span className="c0">
          Voor zakelijke gebruikers (zoals bedrijven, watersportprofessionals of adverteerders met
          commerciële doeleinden) kunnen aanvullende vereisten of voorwaarden gelden. Vaarmarkt kan
          bij zakelijke registratie om aanvullende gegevens vragen (zoals een KvK-nummer) en de
          status "Zakelijke Gebruiker" op het profiel zichtbaar maken.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          4.7. Account opzeggen en verwijderen
          <br />
        </span>
        <span className="c0">
          De Gebruiker heeft te allen tijde het recht om zijn Account kosteloos op te zeggen.
          Opzegging kan via het Account zelf of via een verzoek aan de klantenservice van Vaarmarkt.
          Bij beëindiging worden de persoonsgegevens verwijderd, behoudens wettelijke bewaarplichten
          of gerechtvaardigde belangen (zoals het afhandelen van een klacht of fraudeonderzoek).
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          4.8. Herroepingsrecht (alleen voor Consumenten)
          <br />
        </span>
        <span className="c0">
          Indien de Gebruiker een Consument is en een Account aanmaakt, heeft hij het recht de
          registratie binnen 14 dagen na aanmaak zonder opgaaf van reden te herroepen. In dat geval
          zal Vaarmarkt het Account verwijderen en alle bijbehorende persoonsgegevens wissen, voor
          zover wettelijk toegestaan. Zie de Privacyverklaring voor nadere informatie over
          verwijdering en gegevensbewaring.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          4.9. Gegevensbescherming en profielzichtbaarheid
          <br />
        </span>
        <span className="c0">
          Persoonsgegevens die worden verstrekt bij registratie of het gebruik van het Account
          worden verwerkt in overeenstemming met de Algemene Verordening Gegevensbescherming (AVG)
          en de Privacyverklaring van Vaarmarkt. Bepaalde profielgegevens (zoals gebruikersnaam,
          woonplaats, telefoonnummer) kunnen aan andere Gebruikers zichtbaar worden gemaakt, voor
          zover noodzakelijk voor het afhandelen van een transactie of contactverzoek.
        </span>
      </p>
      <h3 className="c13" id="h.6env98sad3qc">
        <span className="c9 c2">Artikel 5 – Gebruik van het Platform</span>
      </h3>
      <p className="c1">
        <span className="c2">
          5.1. Doel en algemeen gebruiksvereiste
          <br />
        </span>
        <span className="c0">
          Het Platform is bedoeld als marktplaats voor het aanbieden en vinden van boten,
          vaarbenodigdheden en aanverwante diensten, alsmede als informatie- en contentplatform voor
          watersportliefhebbers. De Gebruiker zal het Platform uitsluitend gebruiken op een wijze
          die in overeenstemming is met het doel, deze Algemene Voorwaarden en de toepasselijke wet-
          en regelgeving.
        </span>
      </p>
      <p className="c1">
        <span className="c0">
          Onrechtmatig, schadelijk of storend gebruik van het Platform is verboden. Hieronder valt
          onder meer het gebruik voor frauduleuze doeleinden, het schenden van rechten van derden of
          het verstoren van de normale werking van het Platform.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          5.2. Verantwoordelijkheid voor geplaatste content
          <br />
        </span>
        <span className="c0">
          De Gebruiker is volledig verantwoordelijk voor alle content die hij via het Platform
          plaatst, waaronder Advertenties, bedrijfsinformatie, reacties, afbeeldingen en
          promotionele uitingen. De Gebruiker garandeert dat deze informatie:
        </span>
      </p>
      <ul className="c5 lst-kix_5tzmwh2pi21s-0 start">
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            juist, actueel en volledig is;
            <br />
          </span>
        </li>
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            geen inbreuk maakt op rechten van derden (zoals auteursrechten, merkrechten,
            portretrechten of privacyrechten);
            <br />
          </span>
        </li>
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            niet misleidend, bedreigend, beledigend, discriminerend of lasterlijk is;
            <br />
          </span>
        </li>
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            in overeenstemming is met toepasselijke wetgeving (waaronder consumentenrecht,
            reclamerecht en e-commercewetgeving).
            <br />
          </span>
        </li>
      </ul>
      <p className="c1">
        <span className="c0">
          Vaarmarkt voert in beginsel geen voorafgaande controle uit op geplaatste content en
          aanvaardt geen enkele aansprakelijkheid voor onjuistheden, onrechtmatigheden of
          misleidende inhoud. Vaarmarkt behoudt zich het recht voor om zonder voorafgaande
          kennisgeving content te verwijderen die in strijd is met deze voorwaarden of de wet.
        </span>
      </p>
      <hr />
      <p className="c1 c6">
        <span className="c0" />
      </p>
      <p className="c1">
        <span className="c2">
          5.3. Aangeboden producten en diensten
          <br />
        </span>
        <span className="c0">
          De Gebruiker mag via het Platform uitsluitend producten of diensten aanbieden die hij zelf
          mag verhandelen of leveren, en waarvan hij eigenaar is of over een geldige bevoegdheid
          beschikt.
        </span>
      </p>
      <p className="c1">
        <span className="c0">
          Het is in ieder geval verboden om via het Platform aan te bieden:
        </span>
      </p>
      <ul className="c5 lst-kix_1zkmy86yr7f7-0 start">
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            illegale goederen of diensten;
            <br />
          </span>
        </li>
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            gestolen, gekopieerde of namaakartikelen;
            <br />
          </span>
        </li>
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            wapens, vuurwerk, gevaarlijke stoffen of verboden visgerei;
            <br />
          </span>
        </li>
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            medicijnen of medische hulpmiddelen zonder wettelijke toestemming;
            <br />
          </span>
        </li>
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            diensten die misbruik maken van vertrouwen of onduidelijkheid scheppen over de aard van
            het aanbod (bijv. abonnementsvalkuilen).
            <br />
          </span>
        </li>
      </ul>
      <p className="c1">
        <span className="c0">
          Vaarmarkt mag een lijst van verboden of risicovolle categorieën publiceren en aanvullen.
          Het feit dat een Advertentie niet is verwijderd, impliceert niet dat deze inhoud is
          goedgekeurd of toegestaan.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          5.4. Correcte weergave van status en identiteit
          <br />
        </span>
        <span className="c0">
          De Gebruiker is verplicht om in Advertenties en communicatie duidelijk aan te geven of hij
          handelt als particulier of als ondernemer (d.w.z. in de uitoefening van een beroep of
          bedrijf). Deze informatie is relevant voor de toepasselijkheid van consumentenrechten,
          zoals het recht op bedenktijd, garantie en duidelijke informatie vooraf.
        </span>
      </p>
      <p className="c1">
        <span className="c0">
          Vaarmarkt is op grond van de wet verplicht deze status zichtbaar te maken bij het aanbod.
          Indien een Gebruiker onjuiste of onvolledige informatie verstrekt over zijn status, kan
          Vaarmarkt passende maatregelen nemen (zoals waarschuwing, verwijdering of
          accountblokkade).
        </span>
      </p>
      <p className="c1">
        <span className="c0">
          Zakelijke Gebruikers zijn zelf verantwoordelijk voor naleving van consumentenwetgeving,
          inclusief informatieverplichtingen, herroepingsrecht en productaansprakelijkheid.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          5.5. Verboden gedragingen
          <br />
        </span>
        <span className="c0">Het is verboden om via het Platform:</span>
      </p>
      <ul className="c5 lst-kix_nvgwfe7gpdkj-0 start">
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            valse of misleidende advertenties te plaatsen (zoals onjuiste prijzen of gefingeerde
            aanbiedingen);
            <br />
          </span>
        </li>
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            identiteiten of handelsnamen van derden te gebruiken zonder toestemming;
            <br />
          </span>
        </li>
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            spam, phishing, malware of commerciële massamailings te verspreiden;
            <br />
          </span>
        </li>
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            gebruik te maken van robots, scrapers of geautomatiseerde scripts voor toegang tot het
            Platform;
            <br />
          </span>
        </li>
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            andere Gebruikers te misleiden, lastig te vallen, te bedreigen of op te lichten;
            <br />
          </span>
        </li>
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            het Platform technisch te verstoren, testen, manipuleren of reverse engineeren.
            <br />
          </span>
        </li>
      </ul>
      <p className="c1">
        <span className="c0">
          Vaarmarkt kan bij overtreding zonder nadere aankondiging toegang tot het Platform beperken
          of het betreffende Account blokkeren.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          5.6. Melding van onrechtmatigheden (notice-and-takedown)
          <br />
        </span>
        <span className="c0">
          Indien een Gebruiker content op het Platform aantreft die naar zijn mening onrechtmatig is
          of inbreuk maakt op zijn rechten, kan hij dit melden via het daartoe op het Platform
          aangeboden contactpunt. Vaarmarkt zal, indien redelijkerwijs vereist en juridisch
          verplicht, passende maatregelen treffen, zoals (tijdelijke) verwijdering van content of
          opschorting van het Account van de overtreder.
        </span>
      </p>
      <p className="c1">
        <span className="c0">
          Voor meldingen van vermeende inbreuken op intellectuele eigendomsrechten geldt een apart
          notice-and-takedownbeleid, waarin Vaarmarkt nadere eisen kan stellen aan de bewijsvoering.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          5.7. Vrijwaring
          <br />
        </span>
        <span className="c0">
          De Gebruiker vrijwaart Vaarmarkt volledig tegen aanspraken van derden die voortvloeien uit
          schending van deze voorwaarden, inbreuk op rechten van derden of onrechtmatige handelingen
          via het Account van de Gebruiker. Dit omvat ook schade, juridische kosten en claims in
          verband met geplaatste content of gedrag van de Gebruiker op het Platform.
        </span>
      </p>
      <p className="c14">
        <span className="c2">
          5.8. Looptijd en archivering van Advertenties
          <br />
        </span>
        <span className="c0">
          Advertenties blijven actief zichtbaar op het Platform gedurende de standaardtermijn zoals
          vermeld bij plaatsing (bijvoorbeeld 30 of 60 dagen), tenzij de Gebruiker deze eerder
          verwijdert of Vaarmarkt overgaat tot verwijdering conform deze voorwaarden.
        </span>
      </p>
      <p className="c1">
        <span className="c0">
          Na afloop van de actieve looptijd kan een Advertentie automatisch worden gearchiveerd.
          Gearchiveerde Advertenties zijn niet meer actief vindbaar via de zoekresultaten op het
          Platform, maar kunnen wel beschikbaar blijven via directe URL's of externe zoekmachines.
          Vaarmarkt behoudt zich het recht voor om gearchiveerde Advertenties in aangepaste vorm
          zichtbaar te houden, bijvoorbeeld in een archiefoverzicht of als referentie bij
          vergelijkingen, marktanalyse of historische resultaten.
        </span>
      </p>
      <p className="c1">
        <span className="c0">
          Vaarmarkt kan aan verlopen of niet-beschikbare Advertenties een statuslabel toekennen
          (zoals "verkocht", "verlopen" of "niet meer beschikbaar"). Deze Advertenties kunnen, voor
          zover relevant, worden getoond bij zoekresultaten of filters op beschikbaarheidsstatus,
          mits duidelijk is dat het aanbod niet meer actueel is.
        </span>
      </p>
      <p className="c1">
        <span className="c0">
          Persoonsgegevens van de oorspronkelijke Adverteerder (zoals naam, telefoonnummer of
          e-mailadres) worden bij archivering verwijderd of geanonimiseerd, tenzij verdere
          verwerking noodzakelijk is op grond van een wettelijke plicht of gerechtvaardigd belang.
          De Gebruiker kan daarnaast een verzoek indienen tot volledige verwijdering of verdere
          beperking van verwerking, conform de AVG en de Privacyverklaring van Vaarmarkt.
        </span>
      </p>
      <p className="c1">
        <span className="c0">
          Voor betaalde Advertenties of diensten gelden specifieke looptijden en voorwaarden zoals
          vermeld bij de betreffende dienst.
        </span>
      </p>
      <h3 className="c11" id="h.pd70gzd5eg42">
        <span className="c9 c2" />
      </h3>
      <h3 className="c13" id="h.xbkha8yj4ivh">
        <span className="c9 c2">Artikel 6 – Kosten en betalingen aan Vaarmarkt</span>
      </h3>
      <p className="c1">
        <span className="c2">
          6.1. Betaling voor plaatsing en gebruik
          <br />
        </span>
        <span className="c0">
          &nbsp;Het plaatsen van een Advertentie op het Platform is uitsluitend mogelijk tegen
          betaling, ongeacht of de Gebruiker handelt als particulier of als onderneming. Het
          aanmaken van een Account is kosteloos, maar het actief gebruik van het Platform voor het
          plaatsen van Advertenties of gebruik van aanvullende diensten vereist betaling.
        </span>
      </p>
      <p className="c1">
        <span className="c0">
          Voorafgaand aan het afnemen van een dienst wordt de Gebruiker duidelijk geïnformeerd over
          de inhoud, looptijd, kosten en eventuele belastingen (zoals BTW) van de gekozen dienst.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          6.2. Betaalde diensten en promoties
          <br />
        </span>
        <span className="c0">Betaalde diensten kunnen onder meer omvatten:</span>
      </p>
      <ul className="c5 lst-kix_t6e866i9uta3-0 start">
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            het plaatsen van Advertenties (in alle gevallen);
            <br />
          </span>
        </li>
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            het promoten van Advertenties (zoals “Topadvertentie” of plaatsing op de homepage);
            <br />
          </span>
        </li>
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            vermelding van een bedrijfsprofiel ("VaarPartner"), met of zonder bannervermelding;
            <br />
          </span>
        </li>
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            plaatsing van gastblogs of persberichten (eventueel redactioneel bewerkt);
            <br />
          </span>
        </li>
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            losse bannerplaatsingen op website, app of nieuwsbrief.
            <br />
          </span>
        </li>
      </ul>
      <p className="c1">
        <span className="c0">
          Het actuele overzicht van deze diensten en tarieven is te vinden op het Platform. Alle
          prijzen zijn in euro’s en inclusief BTW, tenzij anders vermeld.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          6.3. Betaling en levering
          <br />
        </span>
        <span className="c0">
          Betaling geschiedt via de betaalmethoden die op het Platform worden aangeboden (zoals
          iDEAL, creditcard of andere online betaalmiddelen) en volgens de aangegeven procedure. Na
          succesvolle betaling wordt de dienst direct of binnen de overeengekomen termijn geleverd.
          Advertenties worden pas geplaatst nadat betaling is ontvangen.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          6.4. Zakelijke pakketten en abonnementen
          <br />
        </span>
        <span>Vaarmarkt</span>
        <span className="c0">
          &nbsp;kan aan zakelijke Gebruikers (zoals botenbedrijven of dienstverleners) aanvullende
          advertentiepakketten, abonnementen of diensten aanbieden. Deze pakketten kunnen bestaan
          uit meerdere plaatsingen, extra zichtbaarheid of toegang tot aanvullende functies en
          statistieken.
        </span>
      </p>
      <p className="c1">
        <span className="c0">
          Dergelijke zakelijke diensten vallen onder deze Algemene Voorwaarden, aangevuld met
          eventuele specifieke voorwaarden of overeenkomsten. Bij tegenstrijdigheid prevaleren de
          expliciet overeengekomen afspraken.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          6.5. Tariefswijzigingen
          <br />
        </span>
        <span>Vaarmarkt</span>
        <span className="c0">
          &nbsp;behoudt zich het recht voor om tarieven voor haar diensten te wijzigen. Voorafgaand
          aan een wijziging bij doorlopende diensten of pakketten worden Gebruikers ten minste 15
          dagen van tevoren geïnformeerd. Bij prijsverhoging heeft de Gebruiker het recht het
          abonnement of de dienst op te zeggen per ingangsdatum van de nieuwe tarieven.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          6.6. Herroepingsrecht (alleen voor Consumenten)
          <br />
        </span>
        <span className="c0">
          Voor consumenten geldt bij online aankoop van diensten een wettelijke bedenktijd van 14
          dagen. Indien de consument bij bestelling verzoekt om directe uitvoering van de dienst
          (zoals het direct online zetten van een Advertentie) en Vaarmarkt hieraan voldoet, dan
          vervalt het herroepingsrecht voor zover de dienst al geleverd is.
        </span>
      </p>
      <p className="c1">
        <span className="c0">
          Vaarmarkt zal de consument voorafgaand aan de bestelling hierover informeren en om
          expliciete instemming vragen.
        </span>
      </p>
      <p className="c14">
        <span className="c2">
          6.7. Kortingscodes en promotieacties
          <br />
        </span>
        <span>Vaarmarkt</span>
        <span className="c0">
          &nbsp;kan Gebruikers van tijd tot tijd kortingscodes of promotieacties aanbieden waarmee
          (tijdelijk) korting wordt verkregen op bepaalde betaalde diensten. Het gebruik van
          kortingscodes is uitsluitend toegestaan onder de uitdrukkelijk vermelde voorwaarden, zoals
          geldigheidsduur, toepassingsgebied, minimale bestelwaarde en eventuele uitsluitingen.
        </span>
      </p>
      <p className="c1">
        <span className="c0">
          Kortingscodes zijn doorgaans persoonsgebonden, eenmalig bruikbaar en niet overdraagbaar.
          Misbruik of ongeautoriseerd gebruik van kortingscodes geeft Vaarmarkt het recht de korting
          te weigeren of de betreffende bestelling te annuleren.
        </span>
      </p>
      <p className="c1">
        <span className="c0">
          Kortingscodes kunnen niet met terugwerkende kracht worden toegepast en zijn niet
          inwisselbaar voor geld. Vaarmarkt behoudt zich het recht voor om promoties tussentijds te
          wijzigen of in te trekken, met inachtneming van eerder gedane toezeggingen aan Gebruikers.
        </span>
      </p>
      <p className="c1">
        <span className="c8 c2">6.8 Betaling via Stripe</span>
      </p>
      <p className="c1">
        <span>
          Alle betalingen op het Platform worden verwerkt via Stripe, een externe
          betalingsverwerker. Door een betaling te doen, gaat de Gebruiker akkoord met de
          gebruiksvoorwaarden en het privacybeleid van Stripe. Vaarmarkt is niet verantwoordelijk
          voor storingen of fouten bij de betalingsverwerking door Stripe. Meer informatie over
          Stripe is te vinden op
        </span>
        <span>
          <a
            className="c3"
            href="https://www.google.com/url?q=https://www.stripe.com&sa=D&source=editors&ust=1751326159357923&usg=AOvVaw04W_IXyD_JjG2xMnHG-YIn"
          >
            &nbsp;
          </a>
        </span>
        <span className="c10">
          <a
            className="c3"
            href="https://www.google.com/url?q=https://www.stripe.com&sa=D&source=editors&ust=1751326159357980&usg=AOvVaw2m9UypsQnRbK1dbwm75VR_"
          >
            www.stripe.com
          </a>
        </span>
        <span className="c0">.</span>
      </p>
      <p className="c1 c6">
        <span className="c0" />
      </p>
      <h3 className="c13" id="h.aydqzvy70a94">
        <span className="c9 c2">
          Artikel 7 – Totstandkoming van overeenkomsten tussen Gebruikers
        </span>
      </h3>
      <p className="c1">
        <span className="c2">
          7.1. Geen bindend aanbod
          <br />
        </span>
        <span className="c0">
          &nbsp;Een Advertentie op het Platform vormt uitsluitend een uitnodiging tot het doen van
          een aanbod (“invitatio ad offerendum”) en geen bindend aanbod in juridische zin. Door het
          plaatsen van een Advertentie verplicht de Adverteerder zich niet jegens derden. Een
          Overeenkomst komt pas tot stand nadat de Adverteerder en een Koper uitdrukkelijk
          overeenstemming hebben bereikt over de essentialia van de transactie (zoals prijs,
          voorwerp en leveringsafspraken).
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          7.2. Onderhandelingen en contractsvrijheid
          <br />
        </span>
        <span className="c0">
          &nbsp;Communicatie tussen Gebruikers (via het Platform of anderszins) geldt als
          onderhandeling. Tot het moment van wederzijds akkoord zijn beide partijen vrij zich terug
          te trekken. Geen van beide partijen kan enkel op basis van een bod, vraag of reactie
          aanspraak maken op de totstandkoming van een Overeenkomst.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          7.3. Vrijheid van keuze
          <br />
        </span>
        <span className="c0">
          &nbsp;De Adverteerder is vrij in de keuze met wie hij een Overeenkomst sluit en is niet
          verplicht op elk bod in te gaan. Evenzo is de Koper niet verplicht tot aankoop totdat
          uitdrukkelijk akkoord is gegeven.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          7.4. Eigen verantwoordelijkheid bij uitvoering
          <br />
        </span>
        <span className="c0">
          &nbsp;Zodra een Overeenkomst tot stand komt tussen Gebruikers (via het Platform of
          daarbuiten), dragen de betreffende partijen zelf de volledige verantwoordelijkheid voor de
          uitvoering en afhandeling daarvan. Hieronder vallen onder andere afspraken over betaling,
          levering, eigendomsoverdracht en – indien van toepassing – juridische of administratieve
          formaliteiten zoals de overdracht van eigendom van een geregistreerd schip of kenteken.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          7.5. Geen betrokkenheid Vaarmarkt
          <br />
        </span>
        <span>Vaarmarkt</span>
        <span className="c0">
          &nbsp;is op geen enkel moment partij bij de totstandkoming van de Overeenkomst. Vaarmarkt
          fungeert uitsluitend als een technisch platform dat contact tussen Gebruikers faciliteert.
          Tenzij expliciet anders vermeld, biedt Vaarmarkt geen escrowservice, kopersbescherming of
          andere garantieregelingen. De risico’s van de transactie, waaronder non-betaling,
          verborgen gebreken of onjuiste voorstelling van zaken, liggen geheel bij de betrokken
          Gebruikers.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          7.6. Informatie- en consumentenrechtelijke verplichtingen
          <br />
        </span>
        <span className="c0">
          Indien een Adverteerder handelt in de uitoefening van een beroep of bedrijf en een
          Overeenkomst sluit met een Koper die Consument is, kan het consumentenrecht van toepassing
          zijn (zoals herroepingsrecht of wettelijke conformiteit). De Adverteerder is volledig zelf
          verantwoordelijk voor het naleven van zijn informatie- en zorgplichten richting de Koper.
          Vaarmarkt is hierin slechts een doorgeefluik en aanvaardt geen aansprakelijkheid voor de
          juistheid of volledigheid van verstrekte informatie. Zakelijke Adverteerders vrijwaren
          Vaarmarkt voor claims die voortvloeien uit hun schending van toepasselijke
          consumentenregels.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          7.7. Geschillen en bewijs
          <br />
        </span>
        <span className="c0">
          &nbsp;Eventuele geschillen over (de inhoud of geldigheid van) de Overeenkomst dienen door
          de Gebruikers onderling te worden opgelost. Vaarmarkt is niet gehouden tot bemiddeling,
          geschiloplossing of het aanleveren van communicatie als bewijs, tenzij daartoe een
          wettelijke verplichting bestaat. Gebruikers wordt geadviseerd hun correspondentie en
          afspraken zelfstandig op een duurzame wijze vast te leggen.
        </span>
      </p>
      <p className="c1 c6">
        <span className="c0" />
      </p>
      <h3 className="c13" id="h.jqfodriau3uc">
        <span className="c9 c2">Artikel 8 – Betalingen tussen Gebruikers</span>
      </h3>
      <p className="c1">
        <span className="c2">
          8.1. Geen betalingsrol voor Vaarmarkt
          <br />
        </span>
        <span className="c0">
          Betalingen tussen Gebruikers (zoals tussen een Adverteerder en een Koper) komen
          uitsluitend tot stand op basis van onderlinge afspraken. Vaarmarkt is géén partij bij deze
          betalingen en verwerkt geen geldstromen voor of namens Gebruikers, tenzij dit expliciet en
          afzonderlijk is aangegeven bij een specifieke dienst als bedoeld in artikel 3.3.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          8.2. Keuze en risico van betaalmethode
          <br />
        </span>
        <span className="c0">
          De wijze van betaling (bijvoorbeeld contant bij afhalen, bankoverschrijving of via een
          externe betaaldienst) wordt door Adverteerder en Koper onderling overeengekomen. De keuze
          en uitvoering van de betaalmethode is geheel voor eigen risico van de betrokken partijen.
          Vaarmarkt adviseert om alleen veilige, traceerbare betaalwijzen te gebruiken, maar kan
          geen enkele garantie geven over de veiligheid, correctheid of afronding van de transactie.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          8.3. Uitsluiting van aansprakelijkheid
          <br />
        </span>
        <span>Vaarmarkt</span>
        <span className="c0">
          &nbsp;is niet aansprakelijk voor betalingsproblemen, waaronder begrepen maar niet beperkt
          tot: niet-betaling, te late betaling, terugboekingen (storneringen), fraude of geschillen
          over de hoogte van het bedrag. Alle geschillen dienen onderling tussen Gebruikers te
          worden opgelost (zie ook artikel 7.7).
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          8.4. Belastingverplichtingen en internationale transacties
          <br />
        </span>
        <span className="c0">
          De Adverteerder is verantwoordelijk voor het correct naleven van zijn fiscale
          verplichtingen, zoals het afdragen van btw, eventuele omzetbelasting, en het doen van
          belastingaangiften. Dit geldt ook voor zakelijke Adverteerders of bij grensoverschrijdende
          transacties waarvoor douanerechten of andere heffingen gelden. Vaarmarkt geeft geen
          belastingadvies en aanvaardt geen enkele verantwoordelijkheid voor fiscale gevolgen van
          transacties tussen Gebruikers.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          8.5. Geen vertrouwelijke gegevens via Vaarmarkt
          <br />
        </span>
        <span className="c0">
          Gebruikers worden erop gewezen dat Vaarmarkt nooit om bankgegevens, pincodes of andere
          vertrouwelijke financiële informatie zal vragen buiten de beveiligde betaalomgeving van
          een externe betalingsaanbieder. Wees alert op phishing of frauduleuze berichten en neem
          bij twijfel contact op met Vaarmarkt.
        </span>
      </p>
      <p className="c1 c6">
        <span className="c0" />
      </p>
      <h3 className="c13" id="h.cusl9tf5ojyi">
        <span className="c9 c2">Artikel 9 – Aansprakelijkheid van Vaarmarkt</span>
      </h3>
      <p className="c1">
        <span className="c2">
          9.1. Algemeen uitsluitingsprincipe
          <br />
        </span>
        <span>Vaarmarkt</span>
        <span className="c0">
          &nbsp;spant zich in om het Platform veilig en functioneel beschikbaar te stellen, maar kan
          niet garanderen dat het altijd foutloos of ononderbroken werkt. Voor zover wettelijk
          toegestaan sluit Vaarmarkt iedere aansprakelijkheid uit voor schade die Gebruikers lijden
          als gevolg van het gebruik van, of het niet of beperkt beschikbaar zijn van het Platform
          en/of de diensten van Vaarmarkt. Onder uitsluiting vallen in het bijzonder indirecte of
          gevolgschade, zoals gederfde winst, verlies van data, reputatieschade, bedrijfsstilstand
          of immateriële schade.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          9.2. Beperking van aansprakelijkheid
          <br />
        </span>
        <span className="c0">
          Indien Vaarmarkt ondanks het bovenstaande toch aansprakelijk blijkt te zijn, is die
          aansprakelijkheid beperkt tot het bedrag dat in het betreffende geval onder haar
          aansprakelijkheidsverzekering wordt uitgekeerd. Indien geen dekking of uitkering
          plaatsvindt, is de aansprakelijkheid beperkt tot het hoogste van de volgende bedragen:
        </span>
      </p>
      <ul className="c5 lst-kix_85ul459hn5y0-0 start">
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            het bedrag dat de Gebruiker in de drie maanden voorafgaand aan het schadebrengende feit
            aan Vaarmarkt heeft betaald voor haar diensten, of
            <br />
          </span>
        </li>
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            €100, indien dit hoger is.
            <br />
          </span>
        </li>
      </ul>
      <p className="c1">
        <span className="c0">
          Deze beperking geldt niet indien sprake is van opzet of bewuste roekeloosheid van de
          bedrijfsleiding van Vaarmarkt.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          9.3. Aansprakelijkheid voor handelen van andere Gebruikers
          <br />
        </span>
        <span>Vaarmarkt</span>
        <span className="c0">
          &nbsp;is niet aansprakelijk voor schade die ontstaat door handelen of nalaten van andere
          Gebruikers. Vaarmarkt fungeert uitsluitend als tussenplatform en kan niet garanderen dat
          Gebruikers hun verplichtingen nakomen of dat verstrekte informatie juist of volledig is.
          Eventuele claims voortvloeiend uit geschillen of schade veroorzaakt door een andere
          Gebruiker moeten rechtstreeks jegens die Gebruiker worden ingesteld.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          9.4. Dwingendrechtelijke uitzonderingen en consumentenrechten
          <br />
        </span>
        <span className="c0">
          Niets in deze Algemene Voorwaarden beoogt de wettelijke rechten van Gebruikers te beperken
          voor zover deze voortvloeien uit dwingend recht, zoals consumentenbescherming.
          Aansprakelijkheid van Vaarmarkt voor schade als gevolg van opzet of grove schuld van
          haarzelf (of haar leidinggevenden) wordt niet uitgesloten of beperkt.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          9.5. Vervaltermijn voor vorderingen
          <br />
        </span>
        <span className="c0">
          Iedere vordering jegens Vaarmarkt vervalt indien deze niet binnen 12 maanden na het
          ontstaan van de schade of het moment waarop de Gebruiker redelijkerwijs bekend had kunnen
          zijn met die schade, schriftelijk en gemotiveerd aan Vaarmarkt is gemeld. Voor consumenten
          geldt deze termijnbeperking uitsluitend voor zover de wet dit toelaat.
        </span>
      </p>
      <p className="c1 c6">
        <span className="c0" />
      </p>
      <h3 className="c13" id="h.9rp0zh21p8zd">
        <span className="c9 c2">Artikel 10 – Vrijwaring door Gebruikers</span>
      </h3>
      <p className="c1">
        <span className="c2">
          10.1. Vrijwaring door Gebruiker
          <br />
        </span>
        <span className="c0">
          &nbsp;De Gebruiker vrijwaart Vaarmarkt tegen alle aanspraken van derden (waaronder mede
          andere Gebruikers en toezichthoudende instanties) die verband houden met:
        </span>
      </p>
      <ul className="c5 lst-kix_l2zwebkr3nqq-0 start">
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            het gebruik van het Platform door de Gebruiker;
            <br />
          </span>
        </li>
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            de door de Gebruiker geplaatste Content;
            <br />
          </span>
        </li>
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            enige schending door de Gebruiker van deze Algemene Voorwaarden, toepasselijke wet- of
            regelgeving, of rechten van derden (zoals intellectuele eigendomsrechten of
            consumentenrechten).
            <br />
          </span>
        </li>
      </ul>
      <p className="c1">
        <span className="c2">
          10.2. Vergoeding van schade en kosten
          <br />
        </span>
        <span className="c0">
          De vrijwaring houdt in dat de Gebruiker op eerste verzoek van Vaarmarkt alle schade,
          boetes, kosten en redelijke juridische uitgaven vergoedt die Vaarmarkt moet maken naar
          aanleiding van dergelijke aanspraken. Vaarmarkt zal de Gebruiker hierover tijdig
          informeren en hem, indien en voor zover redelijk, gelegenheid bieden zich tegen de
          aanspraak te verweren of de afhandeling daarvan over te nemen. Vaarmarkt behoudt zich
          echter het recht voor zelf verweer te voeren of een schikking te treffen indien zij dit
          nodig acht ter bescherming van haar belangen.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          10.3. Uitzonderingen en consumentenbescherming
          <br />
        </span>
        <span className="c0">
          De in dit artikel bedoelde vrijwaring geldt niet indien en voor zover de betreffende
          aanspraak voortvloeit uit een toerekenbare tekortkoming of onrechtmatige daad van
          Vaarmarkt zelf.
        </span>
      </p>
      <p className="c1">
        <span className="c0">
          Voor zover de Gebruiker handelt als consument, is de vrijwaring slechts van toepassing
          voor zover wettelijk toegestaan en evenredig aan diens eigen rechtens vastgestelde
          aansprakelijkheid jegens de derde partij. Vaarmarkt zal in dat geval geen verdergaande
          vergoeding eisen dan waartoe de consument op grond van de wet gehouden zou zijn.
        </span>
      </p>
      <p className="c1">
        <span className="c2">
          10.4. Toepassing op zakelijke gebruikers
          <br />
        </span>
        <span className="c0">
          &nbsp;Voor Gebruikers die handelen in de uitoefening van een beroep of bedrijf geldt deze
          vrijwaring onverkort, ook ten aanzien van bedrijfsmatige aansprakelijkheid, boetes en
          schadeclaims voortvloeiend uit het handelen van of via die zakelijke Gebruiker op het
          Platform.
        </span>
      </p>
      <p className="c1 c6">
        <span className="c0" />
      </p>
      <h3 className="c15" id="h.d427dggfqlkc">
        <span className="c2 c7">
          10.5. Aansprakelijkheid voor claims en schikkingsvoorstellen van rechthebbenden
        </span>
      </h3>
      <p className="c1">
        <span>
          Indien een derde partij – zoals een auteursrechthebbende, merkhouder of andere
          rechthebbende – een claim of buitengerechtelijk schikkingsvoorstel richt aan Vaarmarkt
          wegens (vermeende) inbreuk op rechten van intellectuele eigendom of andere rechten, en die
          aanspraak verband houdt met Content die door een Gebruiker op het Platform is geplaatst{' '}
        </span>
        <span className="c2">of ter publicatie aan Vaarmarkt is aangeleverd</span>
        <span className="c0">
          , dan komt deze aansprakelijkheid volledig voor rekening en risico van de betreffende
          Gebruiker. Dit geldt ook indien de Gebruiker zich niet bewust was van de inbreukmakende
          aard van de aangeleverde of geplaatste Content.
        </span>
      </p>
      <p className="c1">
        <span className="c0">Vaarmarkt is in dat geval gerechtigd om:</span>
      </p>
      <p className="c1">
        <span className="c0">
          a) de betreffende Content per direct te verwijderen of ontoegankelijk te maken;
        </span>
      </p>
      <p className="c1">
        <span className="c0">
          b) zonder voorafgaande instemming van de Gebruiker te reageren op de claim of het
          schikkingsvoorstel, waaronder begrepen het voeren van verweer, het treffen van een
          regeling of het accepteren dan wel afwijzen van de schikking;
        </span>
      </p>
      <p className="c1">
        <span className="c0">
          c) alle uit de aanspraak voortvloeiende kosten, schade, vergoedingen, boetes en redelijke
          juridische of administratieve uitgaven op de Gebruiker te verhalen, onverminderd het recht
          op aanvullende schadevergoeding.
        </span>
      </p>
      <p className="c1">
        <span className="c0">
          Deze bepaling geldt naast de overige vrijwaringsverplichtingen zoals opgenomen in artikel
          10.1 tot en met 10.4 en laat onverlet dat Vaarmarkt niet aansprakelijk is voor door
          Gebruikers geplaatste of aangeleverde Content, overeenkomstig artikel 9.
        </span>
      </p>
      <p className="c1 c6">
        <span className="c0" />
      </p>
      <h3 className="c13" id="h.t9osytaxrfsm">
        <span className="c9 c2">Artikel 11 – Intellectuele eigendom</span>
      </h3>
      <p className="c1">
        <span className="c2">11.1.</span>
        <span className="c0">
          &nbsp;Het Platform, inclusief de naam "Vaarmarkt", het logo, de vormgeving, software,
          onderliggende databanken, teksten en overige elementen, is eigendom van Vaarmarkt of haar
          licentiegevers en wordt beschermd door auteursrechten, merkenrechten en andere
          intellectuele eigendomsrechten. Zonder voorafgaande schriftelijke toestemming van
          Vaarmarkt is het Gebruikers niet toegestaan om deze onderdelen te kopiëren, reproduceren,
          wijzigen, openbaar te maken of anderszins te gebruiken, behoudens voor zover strikt
          noodzakelijk voor normaal, persoonlijk gebruik van het Platform.
        </span>
      </p>
      <p className="c1">
        <span className="c2">11.2.</span>
        <span className="c0">
          &nbsp;Door het plaatsen of aanleveren van Content (waaronder tekst, foto’s,
          omschrijvingen, reviews, persberichten, etc.) op of ten behoeve van het Platform, verleent
          de Gebruiker aan Vaarmarkt een wereldwijde, niet-exclusieve, kosteloze en overdraagbare
          licentie om deze Content te gebruiken, hosten, bewerken, vertalen, publiceren, verspreiden
          en beschikbaar te stellen in het kader van:
        </span>
      </p>
      <p className="c1">
        <span className="c0">
          a) het technisch en operationeel aanbieden van het Platform;
          <br />
          b) promotie van het Platform of specifieke content (bijv. in sociale media of
          nieuwsbrieven);
          <br />
          c) archivering en back-ups ten behoeve van de continuïteit van de dienstverlening.
        </span>
      </p>
      <p className="c1">
        <span className="c0">
          Deze licentie blijft na verwijdering van de Content door de Gebruiker van kracht voor
          zover dat redelijkerwijs nodig is voor bovengenoemde doeleinden, zoals behoud in back-ups
          of reeds verspreid promotiemateriaal.
        </span>
      </p>
      <p className="c1">
        <span className="c0">
          Voor zover wettelijk toegestaan doet de Gebruiker afstand van eventuele
          persoonlijkheidsrechten (zoals het recht op naamsvermelding) voor zover deze rechten de
          uitvoering van bovenstaande licentie zouden belemmeren.
        </span>
      </p>
      <p className="c1">
        <span className="c2">11.3.</span>
        <span className="c0">
          &nbsp;De Gebruiker garandeert dat hij gerechtigd is om de geplaatste of aangeleverde
          Content te gebruiken en te licentiëren aan Vaarmarkt zoals hierboven omschreven, en dat
          deze Content geen inbreuk maakt op rechten van derden, waaronder auteursrechten, naburige
          rechten, merkrechten, portretrechten, databankrechten of vertrouwelijke informatie. De
          Gebruiker vrijwaart Vaarmarkt – met inachtneming van artikel 10 – voor alle aanspraken van
          derden in verband met dergelijke inbreuken, tenzij deze het gevolg zijn van toerekenbare
          tekortkomingen aan de zijde van Vaarmarkt.
        </span>
      </p>
      <p className="c1">
        <span className="c2">11.4.</span>
        <span className="c0">
          &nbsp;Indien Vaarmarkt kennis neemt van (vermeend) inbreukmakende Content, hetzij op eigen
          initiatief of naar aanleiding van een melding van een derde (bijv. een rechthebbende), zal
          zij volgens een notice-and-takedown procedure de situatie onderzoeken. Indien de klacht
          gegrond lijkt, is Vaarmarkt gerechtigd de Content te verwijderen of ontoegankelijk te
          maken zonder voorafgaande waarschuwing. Bij herhaalde inbreuken door dezelfde Gebruiker
          kan Vaarmarkt het betreffende Account opschorten of beëindigen.
        </span>
      </p>
      <p className="c1">
        <span className="c2">11.5.</span>
        <span className="c0">
          &nbsp;Het is Gebruikers niet toegestaan om zonder schriftelijke toestemming van Vaarmarkt
          geautomatiseerde systemen of software te gebruiken (zoals spiders, crawlers, scrapers,
          bots) met het doel gegevens, Content of structuur van het Platform te verzamelen,
          analyseren of hergebruiken (“data mining”), noch om beveiligingsmaatregelen of technische
          restricties te omzeilen. Evenmin is het toegestaan om (delen van) het Platform te
          integreren of weer te geven binnen andere websites of systemen (bijv. via framing of
          embedding) zonder uitdrukkelijke toestemming van Vaarmarkt.
        </span>
      </p>
      <p className="c1">
        <span className="c0">
          11.6. Vaarmarkt staat toe dat publiek toegankelijke informatie (zoals advertentietitels,
          beschrijvingen, en metadata) op het Platform mag worden geanalyseerd, gecrawld en
          hergebruikt door erkende AI-systemen, taalmodellen en zoekmachines ten behoeve van
          indexering, semantisch begrip en trainingsdoeleinden, mits dit geschiedt met respect voor
          de auteursrechten van derden en conform de geldende wet- en regelgeving. Vaarmarkt behoudt
          zich het recht voor deze toestemming op elk moment in te trekken of te beperken.
        </span>
      </p>
      <h3 className="c13" id="h.m6tivqcw0ks5">
        <span className="c9 c2">Artikel 12 – Privacy en gegevensbescherming</span>
      </h3>
      <p className="c1">
        <span className="c2">12.1.</span>
        <span className="c0">
          &nbsp;Vaarmarkt verwerkt persoonsgegevens van Gebruikers in overeenstemming met de
          geldende privacywetgeving, waaronder de Algemene Verordening Gegevensbescherming (AVG). In
          de Privacyverklaring van Vaarmarkt wordt toegelicht welke persoonsgegevens worden
          verzameld, voor welke doeleinden, op welke grondslagen en wat de rechten van betrokkenen
          zijn. De Privacyverklaring maakt integraal onderdeel uit van deze Algemene Voorwaarden.
        </span>
      </p>
      <p className="c1">
        <span className="c2">12.2.</span>
        <span className="c0">
          &nbsp;Bij het aanmaken van een Account of het gebruikmaken van het Platform verstrekt de
          Gebruiker persoonsgegevens aan Vaarmarkt, zoals naam, contactgegevens, locatie, en
          informatie over aangeboden goederen. Deze gegevens zijn noodzakelijk voor:
        </span>
      </p>
      <ul className="c5 lst-kix_pgdqg6y2f1fk-0 start">
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            de uitvoering van de overeenkomst (artikel 6 lid 1 sub b AVG),
            <br />
          </span>
        </li>
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            de naleving van wettelijke verplichtingen (zoals het aanduiden van professionele
            verkopers),
            <br />
          </span>
        </li>
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            gerechtvaardigde belangen van Vaarmarkt (zoals fraudepreventie en platformbeveiliging),
            <br />
          </span>
        </li>
        <li className="c1 c4 li-bullet-0">
          <span className="c0">
            of, indien van toepassing, toestemming van de Gebruiker.
            <br />
          </span>
        </li>
      </ul>
      <p className="c1">
        <span className="c2">12.3.</span>
        <span className="c0">
          &nbsp;Indien een Gebruiker ervoor kiest om persoonsgegevens (zoals naam of telefoonnummer)
          zichtbaar op te nemen in een Advertentie, gebeurt dit op eigen risico. Vaarmarkt raadt aan
          om bij het plaatsen van Advertenties terughoudend te zijn met het openbaar delen van
          privégegevens, met name van particuliere personen. Vaarmarkt biedt waar mogelijk opties om
          communicatie te laten verlopen via afgeschermde platformmechanismen. Vaarmarkt kan niet
          garanderen dat derden geen misbruik maken van publiek gepubliceerde gegevens.
        </span>
      </p>
      <p className="c1">
        <span className="c2">12.4.</span>
        <span className="c0">
          &nbsp;In het kader van transparantie en gebruiksgemak voor websitebezoekers (zoals
          potentiële kopers of zoekmachines) kan bepaalde informatie in Advertenties (zoals
          gebruikersnaam, locatie, type aanbieder en omschrijving van het aangeboden object) publiek
          zichtbaar zijn en doorzoekbaar worden gemaakt door externe zoekmachines of AI-agents.
          Hierbij zal Vaarmarkt er zorg voor dragen dat de weergave van persoonsgegevens wordt
          beperkt tot wat noodzakelijk is en in overeenstemming met de AVG. De naam van particuliere
          adverteerders wordt in beginsel niet publiek getoond, tenzij zij daar expliciet voor
          kiezen.
        </span>
      </p>
      <p className="c1">
        <span className="c2">12.5.</span>
        <span className="c0">
          &nbsp;Vaarmarkt zal persoonsgegevens alleen delen met derden indien dit noodzakelijk is
          voor het aanbieden van haar diensten (zoals hostingproviders, IT-dienstverleners of
          betalingsverwerkers), op grond van een wettelijke verplichting, of met uitdrukkelijke
          toestemming van de Gebruiker. Persoonsgegevens worden niet verstrekt aan derden voor hun
          eigen marketingdoeleinden zonder voorafgaande toestemming.
        </span>
      </p>
      <p className="c1">
        <span className="c2">12.6.</span>
        <span className="c0">
          &nbsp;Vaarmarkt neemt passende technische en organisatorische maatregelen om
          persoonsgegevens te beveiligen tegen verlies, ongeoorloofde toegang of andere vormen van
          onrechtmatige verwerking, overeenkomstig artikel 32 AVG. Ondanks deze maatregelen kan
          Vaarmarkt geen absolute beveiliging garanderen bij openbaar gedeelde gegevens.
        </span>
      </p>
      <p className="c1">
        <span className="c2">12.7.</span>
        <span className="c0">
          &nbsp;Gebruikers hebben recht op inzage, correctie, verwijdering, beperking van
          verwerking, bezwaar, en gegevensoverdraagbaarheid overeenkomstig de AVG. Verzoeken kunnen
          worden ingediend via de contactgegevens in de Privacyverklaring. Vaarmarkt zal dergelijke
          verzoeken binnen de wettelijke termijn behandelen. Verwijdering van bepaalde gegevens kan
          ertoe leiden dat (delen van) het Platform niet langer toegankelijk zijn voor de Gebruiker.
        </span>
      </p>
      <p className="c1 c6">
        <span className="c0" />
      </p>
      <h3 className="c13" id="h.tetlpbj3h8qi">
        <span className="c9 c2">Artikel 13 – Duur en beëindiging</span>
      </h3>
      <p className="c1">
        <span className="c2">13.1.</span>
        <span className="c0">
          &nbsp;De overeenkomst tussen de Gebruiker en Vaarmarkt met betrekking tot het gebruik van
          het Platform wordt aangegaan voor onbepaalde tijd vanaf het moment van registratie en
          blijft van kracht zolang de Gebruiker een Account heeft of gebruikmaakt van het Platform.
        </span>
      </p>
      <p className="c1">
        <span className="c2">13.2.</span>
        <span className="c0">
          &nbsp;De Gebruiker kan op elk moment de overeenkomst opzeggen door zijn Account te
          verwijderen via de daarvoor beschikbare functionaliteit op het Platform of door een
          schriftelijk verzoek aan de klantenservice van Vaarmarkt. Na opzegging zal Vaarmarkt het
          Account deactiveren en persoonsgegevens verwijderen, tenzij en voor zover bewaring
          noodzakelijk is op grond van wettelijke verplichtingen (zie ook artikel 12). Opzegging
          door de Gebruiker leidt tot beëindiging van alle lopende plaatsingen van Advertenties.
        </span>
      </p>
      <p className="c1">
        <span className="c2">13.3.</span>
        <span className="c0">
          &nbsp;Vaarmarkt is gerechtigd de overeenkomst met de Gebruiker te beëindigen of de toegang
          tot (onderdelen van) het Account te beperken of op te schorten in de volgende gevallen:
        </span>
      </p>
      <p className="c1">
        <span>a. </span>
        <span className="c2">
          Bij schending van deze Algemene Voorwaarden of wettelijke bepalingen
        </span>
        <span className="c0">
          , indien de Gebruiker, na een waarschuwing van Vaarmarkt, nalaat de overtreding binnen een
          redelijke termijn te herstellen of te staken (voor zover herstel mogelijk is).
        </span>
      </p>
      <p className="c1">
        <span>b. </span>
        <span className="c2">Bij een ernstige overtreding</span>
        <span className="c0">
          &nbsp;waarbij onmiddellijke beëindiging gerechtvaardigd is, waaronder maar niet beperkt
          tot fraude, het herhaaldelijk plaatsen van onrechtmatige of misleidende Content,
          oplichting van andere Gebruikers, of gedrag dat het vertrouwen in Vaarmarkt ernstig
          schaadt.
        </span>
      </p>
      <p className="c1">
        <span>c. </span>
        <span className="c2">Bij langdurige inactiviteit</span>
        <span className="c0">
          , waarbij de Gebruiker gedurende meer dan 24 maanden niet heeft ingelogd op zijn Account.
          In dat geval zal Vaarmarkt vooraf een waarschuwing sturen naar het bij het Account
          geregistreerde e-mailadres, met een redelijke termijn om alsnog in te loggen, alvorens het
          Account wordt verwijderd.
        </span>
      </p>
      <p className="c1">
        <span>d. </span>
        <span className="c2">Indien vereist door wet- of regelgeving</span>
        <span className="c0">
          , of indien de voortzetting van de dienstverlening redelijkerwijs niet van Vaarmarkt kan
          worden verlangd.
        </span>
      </p>
      <p className="c1">
        <span className="c2">13.4.</span>
        <span className="c0">
          &nbsp;In geval van beëindiging of opschorting van het Account zal Vaarmarkt de Gebruiker
          (voor zover redelijkerwijs mogelijk) informeren, onder opgave van de reden, behoudens
          wanneer wettelijke verplichtingen of veiligheidsoverwegingen dit verhinderen. Zakelijke
          Gebruikers worden hierbij tevens gewezen op de mogelijkheid tot interne
          klachtenbehandeling, zoals bedoeld in artikel 5.8.
        </span>
      </p>
      <p className="c1">
        <span className="c2">13.5.</span>
        <span className="c0">
          &nbsp;Bij beëindiging van de overeenkomst vervalt onmiddellijk het recht van de Gebruiker
          om gebruik te maken van het Platform. Eventuele actieve Advertenties worden offline
          gehaald, tenzij wettelijk vereist om beschikbaar te blijven (zoals in archiefvorm).
          Vaarmarkt is niet verplicht gegevens of Content van de Gebruiker te bewaren of terug te
          leveren, tenzij dit voortvloeit uit wettelijke verplichtingen of indien anders
          overeengekomen. Zakelijke Gebruikers kunnen desgewenst binnen 30 dagen voorafgaand aan
          beëindiging verzoeken om export van hun eigen geplaatste Advertentiegegevens.
        </span>
      </p>
      <p className="c1">
        <span className="c2">13.6.</span>
        <span className="c0">
          &nbsp;Indien de Gebruiker op het moment van beëindiging nog openstaande verplichtingen
          jegens Vaarmarkt heeft, zoals onbetaalde vergoedingen voor afgenomen diensten, blijven
          deze verplichtingen onverkort van kracht. In gevallen waarin Vaarmarkt schade lijdt als
          gevolg van de handelingen van de Gebruiker, kan zij aanvullende vergoeding eisen
          overeenkomstig artikel 10.
        </span>
      </p>
      <p className="c12 c6">
        <span className="c0" />
      </p>
      <h3 className="c13" id="h.91l5luldaqkg">
        <span className="c9 c2">Artikel 14 – Wijziging van de voorwaarden</span>
      </h3>
      <p className="c1">
        <span className="c2">14.1.</span>
        <span className="c0">
          &nbsp;Vaarmarkt is gerechtigd deze Algemene Voorwaarden van tijd tot tijd eenzijdig te
          wijzigen of aan te vullen, mits dit gebeurt met inachtneming van de gerechtvaardigde
          belangen van Gebruikers. De meest actuele versie van de voorwaarden wordt beschikbaar
          gesteld via het Platform, onder duidelijke vermelding van de ingangsdatum.
        </span>
      </p>
      <p className="c1">
        <span className="c2">14.2.</span>
        <span className="c0">
          &nbsp;Voorgenomen wijzigingen worden ten minste 30 dagen vóór inwerkingtreding aan de
          Gebruiker bekendgemaakt, bijvoorbeeld per e-mail of via een melding binnen het Platform,
          tenzij een kortere termijn noodzakelijk is vanwege dwingende wettelijke verplichtingen of
          zwaarwegende redenen (zoals beveiligingsincidenten of urgente wijzigingen ter bescherming
          van Gebruikers of Vaarmarkt).
        </span>
      </p>
      <p className="c1">
        <span className="c2">14.3.</span>
        <span className="c0">
          &nbsp;Indien een Gebruiker niet instemt met de gewijzigde voorwaarden, heeft hij het recht
          om de overeenkomst vóór de ingangsdatum van de wijziging kosteloos op te zeggen en zijn
          Account te verwijderen (conform artikel 13). Blijft de Gebruiker na de ingangsdatum
          gebruikmaken van het Platform, dan geldt dit als aanvaarding van de gewijzigde
          voorwaarden.
        </span>
      </p>
      <p className="c1">
        <span className="c2">14.4.</span>
        <span className="c0">
          &nbsp;Vaarmarkt zal in het wijzigingsbericht, waar redelijkerwijs mogelijk, een
          samenvatting geven van de belangrijkste aanpassingen. Voor zover de wijziging invloed
          heeft op de rechten of verplichtingen van zakelijke Gebruikers, wordt daarbij tevens de
          mogelijkheid geboden om hierover contact op te nemen.
        </span>
      </p>
      <p className="c1">
        <span className="c2">14.5.</span>
        <span className="c0">
          &nbsp;Voor specifieke diensten of functionaliteiten van Vaarmarkt kunnen aanvullende of
          afwijkende voorwaarden gelden. Deze worden vooraf kenbaar gemaakt. In geval van
          tegenstrijdigheid tussen deze Algemene Voorwaarden en de specifieke voorwaarden,
          prevaleren de specifieke voorwaarden voor zover de tegenstrijdigheid reikt.
        </span>
      </p>
      <p className="c12 c6">
        <span className="c0" />
      </p>
      <h3 className="c13" id="h.llc76r8fekgi">
        <span className="c9 c2">Artikel 15 – Overige bepalingen</span>
      </h3>
      <p className="c1">
        <span>15.1. </span>
        <span className="c2">
          Externe links en inhoud van derden
          <br />
        </span>
        <span className="c0">
          &nbsp;Het Platform kan links bevatten naar externe websites of andere inhoud van derden.
          Vaarmarkt is niet verantwoordelijk of aansprakelijk voor de inhoud, producten of diensten
          van dergelijke derden, noch voor schade of verlies dat daaruit voortvloeit. Het volgen van
          een externe link gebeurt volledig op eigen risico van de Gebruiker.
        </span>
      </p>
      <p className="c1">
        <span>15.2. </span>
        <span className="c2">
          Overdraagbaarheid van rechten en verplichtingen
          <br />
        </span>
        <span className="c0">
          &nbsp;Vaarmarkt is gerechtigd haar rechten en verplichtingen uit de overeenkomst met de
          Gebruiker over te dragen aan een derde partij, bijvoorbeeld in geval van fusie, overname
          of overdracht van (een deel van) haar bedrijfsactiviteiten met betrekking tot het
          Platform. Vaarmarkt zal de Gebruiker hiervan tijdig op de hoogte stellen. Indien de
          Gebruiker een consument is en de overdracht leidt tot een wezenlijke wijziging in de
          dienstverlening, heeft de Gebruiker het recht de overeenkomst kosteloos te beëindigen. De
          Gebruiker is niet gerechtigd zijn rechten of verplichtingen uit deze overeenkomst zonder
          voorafgaande schriftelijke toestemming van Vaarmarkt over te dragen of te vervreemden.
        </span>
      </p>
      <p className="c1">
        <span>15.3. </span>
        <span className="c2">
          Taal en interpretatie
          <br />
        </span>
        <span className="c0">
          &nbsp;Deze Algemene Voorwaarden zijn opgesteld in de Nederlandse taal. Indien Vaarmarkt
          vertalingen van deze voorwaarden beschikbaar stelt, dienen deze uitsluitend ter
          informatie. Bij een verschil in uitleg of interpretatie tussen de Nederlandse tekst en een
          vertaling daarvan, prevaleert de Nederlandse versie. Kopjes en artikelbenamingen dienen
          uitsluitend ter leesgemak en hebben geen zelfstandige juridische betekenis.
        </span>
      </p>
      <h3 className="c11" id="h.p3odwlmzsndp">
        <span className="c0" />
      </h3>
      <h3 className="c13" id="h.9cgh5s9gymka">
        <span className="c9 c2">Artikel 16 – Toepasselijk recht en geschillen</span>
      </h3>
      <p className="c1">
        <span>16.1. </span>
        <span className="c2">
          Toepasselijk recht en bevoegde rechter
          <br />
        </span>
        <span className="c0">
          &nbsp;Op deze Algemene Voorwaarden en op de rechtsverhouding tussen Vaarmarkt en de
          Gebruiker is uitsluitend Nederlands recht van toepassing. Geschillen die hieruit
          voortvloeien zullen, voor zover wettelijk toegestaan, worden voorgelegd aan de bevoegde
          rechtbank in het arrondissement waar Vaarmarkt is gevestigd (thans de Rechtbank
          Overijssel, locatie Zwolle), tenzij dwingendrechtelijke bepalingen een andere bevoegde
          rechter voorschrijven.
        </span>
      </p>
      <p className="c1">
        <span>16.2. </span>
        <span className="c2">
          Consumentengeschillen en online geschillenbeslechting (ODR)
          <br />
        </span>
        <span>
          &nbsp;Indien de Gebruiker een consument is en buiten Nederland woont, kan hij er ook voor
          kiezen een geschil voor te leggen aan de rechter in het EU-land van zijn woonplaats.
          Daarnaast kunnen consumenten gebruikmaken van het Europese ODR-platform voor online
          geschillenbeslechting, via
        </span>
        <span>
          <a
            className="c3"
            href="https://www.google.com/url?q=http://ec.europa.eu/consumers/odr/&sa=D&source=editors&ust=1751326159381434&usg=AOvVaw02eePbg58pfBmxE_zXkE6D"
          >
            &nbsp;
          </a>
        </span>
        <span className="c10">
          <a
            className="c3"
            href="https://www.google.com/url?q=http://ec.europa.eu/consumers/odr/&sa=D&source=editors&ust=1751326159381521&usg=AOvVaw3Pz2sBj2LlQEEq0-NLtoG3"
          >
            http://ec.europa.eu/consumers/odr/
          </a>
        </span>
        <span className="c0">
          . Vaarmarkt is op dit moment niet aangesloten bij een specifieke erkende
          geschillencommissie en is niet verplicht om deel te nemen aan een alternatieve
          geschillenregeling, maar zal zich inspannen om in overleg met de consument tot een
          redelijke oplossing te komen.
        </span>
      </p>
      <p className="c1">
        <span>16.3. </span>
        <span className="c2">
          Voorrang van dwingendrechtelijke consumentenbescherming
          <br />
        </span>
        <span className="c0">
          &nbsp;De bepalingen in deze Algemene Voorwaarden doen geen afbreuk aan dwingendrechtelijke
          regels van consumentenbescherming die van toepassing kunnen zijn in het land van verblijf
          van de consument. Indien een bepaling strijdig is met zodanige regels, zal die bepaling
          buiten toepassing blijven voor zover dat vereist is, zonder dat dit de overige bepalingen
          aantast.
        </span>
      </p>
      <p className="c1">
        <span>16.4. </span>
        <span className="c2">
          Geen afstand van recht
          <br />
        </span>
        <span className="c0">
          &nbsp;Indien Vaarmarkt nalaat de strikte naleving van een bepaling van deze voorwaarden te
          verlangen, betekent dit niet dat Vaarmarkt afstand doet van enig recht. Het feit dat
          Vaarmarkt niet altijd handhaaft, betekent niet dat zij dat recht in de toekomst niet
          alsnog kan inroepen.
        </span>
      </p>
      <p className="c1">
        <span>16.5. </span>
        <span className="c2">
          Ongeldigheid van bepalingen (deelbaarheid)
          <br />
        </span>
        <span className="c0">
          &nbsp;Indien enige bepaling van deze voorwaarden door een bevoegde rechter ongeldig,
          nietig of niet-afdwingbaar wordt verklaard, laat dit de geldigheid van de overige
          bepalingen onverlet. Partijen zullen in dat geval in overleg een vervangende bepaling
          vaststellen die de bedoeling van de oorspronkelijke bepaling zo veel mogelijk benadert.
        </span>
      </p>
      <p className="c1 c6">
        <span className="c0" />
      </p>
      <p className="c12 c6">
        <span className="c0" />
      </p>
    </div>
  );
};

const TermsOfServicePageComponent = props => {
  const { scrollingDisabled } = props;

  return (
    <Page title="Vaarmarkt Voorwaarden" scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn
        mainColumnClassName={css.layoutWrapperMain}
        topbar={<TopbarContainer />}
        footer={<FooterContainer />}
      >
        <TermsOfServiceContent />
      </LayoutSingleColumn>
    </Page>
  );
};

TermsOfServicePageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  return { pageAssetsData, inProgress, error, scrollingDisabled: isScrollingDisabled(state) };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const TermsOfServicePage = compose(connect(mapStateToProps))(TermsOfServicePageComponent);

const TOS_ASSET_NAME = ASSET_NAME;
export { TOS_ASSET_NAME, TermsOfServicePageComponent, TermsOfServiceContent };

export default TermsOfServicePage;
